export default __webpack_public_path__ + "static/media/preseasongraph.348e6787.png";